import './polyfills'
import browserUpdate from 'browser-update'
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import createBrowserHistory from 'history/createBrowserHistory'
import { ConnectedRouter } from 'connected-react-router'

import configureStore from './state/configureStore'
import LocaleProvider from './containers/LocaleProvider'
import ThemeLoader from './containers/ThemeLoader'
import App from './containers/App';
import * as serviceWorker from './serviceWorker';

browserUpdate({
  required: {
    e: -2, // edge
    f: 47, // firefox
    c: 54, // chrome
    s: '10.1' // safari
  },
  reminder: 24,
  newwindow: true
})

const history = createBrowserHistory()
const store = configureStore(history)
const MOUNT_NODE = document.getElementById('root')

const render = () => {
  ReactDOM.render((
    <Provider store={store}>
      <ThemeLoader>
        <LocaleProvider defaultLocale='es'>
          <ConnectedRouter history={history}>
            <App />
          </ConnectedRouter>
        </LocaleProvider>
      </ThemeLoader>
    </Provider>
  ), MOUNT_NODE)
}

render()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
